// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginScreen {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    row-gap: 24px;
}

.loginForm {
    
    
    input {
        padding: 12px 10px;
        border-radius: 8px;
        border-style: solid;
        border-width: 1px;
        border-color: #B2B2B2;
        min-width: 180px;
    }

    .row {
        display: flex;
        flex-direction: column;
        padding: 4px 0;
    }
    
    label {
        padding-bottom: 4px;
    }
    
    button {
        margin-top: 8px;
        padding: 12px;
        width: 100%;
        border-radius: 8px;
        border-style: solid;
        border-width: 1px;
        border-color: #B2B2B2;
    }
}




`, "",{"version":3,"sources":["webpack://./src/pages/LoginScreen/LoginScreen.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;AACjB;;AAEA;;;IAGI;QACI,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,qBAAqB;QACrB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,aAAa;QACb,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,qBAAqB;IACzB;AACJ","sourcesContent":[".loginScreen {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    row-gap: 24px;\n}\n\n.loginForm {\n    \n    \n    input {\n        padding: 12px 10px;\n        border-radius: 8px;\n        border-style: solid;\n        border-width: 1px;\n        border-color: #B2B2B2;\n        min-width: 180px;\n    }\n\n    .row {\n        display: flex;\n        flex-direction: column;\n        padding: 4px 0;\n    }\n    \n    label {\n        padding-bottom: 4px;\n    }\n    \n    button {\n        margin-top: 8px;\n        padding: 12px;\n        width: 100%;\n        border-radius: 8px;\n        border-style: solid;\n        border-width: 1px;\n        border-color: #B2B2B2;\n    }\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
